import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { AemService, CommonService, UserInfoService } from 'abs-ngx-library/src/lib/core';
declare const $: any;

@Component({
    selector: 'cart-slot-modal-al',
    templateUrl: './cart-slot-modal-al.component.html'
})
export class CartSlotModalALComponent {
        public reservedTimeIntent: string;
        public isCateringEnabled: boolean;
        public isDigitalDeliPdsModalEnabled: boolean;
       @Input() modalData: any;
       @Input() product: any;
       @Input() customizationData:any;
   
       @Output() closeModalEvent = new EventEmitter<any>();
       @Output() refreshModalEvent = new EventEmitter<number>();
       @Output() startCustomizationEvent = new EventEmitter<void>();
       @Output() handleSlotEvent = new EventEmitter<{ type: string; modalId: string }>();
       @Output() addAnywayEvent = new EventEmitter<string>();
       @Output() previousPageEvent = new EventEmitter<void>();
       @Output() addAndUpdateEvent = new EventEmitter<string>();
       @Output() addPreviousCustomizationEvent = new EventEmitter<void>();
       @Output() addModifyPreviousCustomizationEvent = new EventEmitter<void>();
       @Output() addPreorderItemEvent = new EventEmitter<void>();

       constructor(private _commonService: CommonService,private _userInfoService:UserInfoService, private _aemService: AemService) {
            this.reservedTimeIntent = this._userInfoService.getUserChannel();
            this.isCateringEnabled = !this._aemService.getFeatureFlagByNameDisable('isCateringDisabled');
            this.isDigitalDeliPdsModalEnabled = !this._aemService.getFeatureFlagByNameDisable('isDigitalDeliPdsModalDisabled');
       }
        /**
         * @description
         * This method is used to handle the changes in the modal data.
         * @param changes
         */
        ngOnChanges(changes: SimpleChanges): void {
            if (changes['modalData'] && changes['modalData'].currentValue) {
                this.displayModal(changes['modalData'].currentValue);
            }
        }
        /**
         * @description
         * This method is used to handle the keydown event for the modal.
         * @param $event
         * @param modelId
         */
        public onKeydownModalEvent($event :any, modelId :string){
            const focusableElements = 'button:not([disabled]) , a, [tabindex]:not([tabindex="-1"])';
            this._commonService.handleTabFocus($event, `#${modelId}`, document.getElementById(`${modelId}`).parentElement, focusableElements);
        }
        
        /**
         * @description
         * This method is used to display the modal.
         * @param modalData
         */
        private displayModal(modalData: any) {
            const { modalId, modalOptions, closeBtnSelector, modalFlag, analyticsTag } = modalData;
            const modalIdSelector =`#${modalId}`;
            const modalStepper = this;
        
            // 🔥 1. Force close existing modal if it's already shown
            // if ($(modalIdSelector).hasClass('show')) {
            //     ($(modalIdSelector) as any).modal('hide');
            // }
        
            // 🔥 2. Unbind previously attached event listeners
            $(modalIdSelector).off('shown.bs.modal hidden.bs.modal');
        
            // 🔥 3. Remove the DOM node if it already exists (cleanup)
            // if ($(modalIdSelector).length) {
            //     $(modalIdSelector).remove();
            // }
        
            // 🔥 4. Append modal again to body/footer (ensures fresh DOM rendering)
            setTimeout(() => {
        
                if (modalFlag) {
                    this[modalFlag] = true;
                }
        
                ($(modalIdSelector) as any).modal(modalOptions).appendTo('.unified-footer');
        

                $(modalIdSelector).on('shown.bs.modal', function () {
                    setTimeout(() => {
                        $(closeBtnSelector).focus();
                    }, 100);
                });
        
                $(modalIdSelector).on('hidden.bs.modal', function () {
                    if (modalFlag) {
                        modalStepper[modalFlag] = false;
                    }
                    modalStepper.handleClose();
                    $(modalIdSelector).remove();
                    $(`#addButton_${modalStepper.product?.id}`).focus();
                });
        
                if (analyticsTag) {
                    this.analyticsEvents('modalView', analyticsTag);
                }
            }, 100);
        }
    
        /**
          * @description
          * This method is used to handle the close event.
          */ 
        public handleClose(): void {
            const event = {
                ctaRefId: this.modalData?.ctaRefId
            }
            this.closeModalEvent.emit(event);
        }

         /**
          * @description
          * This method is used to handle the refresh event.
          */
            public handleRefresh(){
                this.refreshModalEvent.emit();
            }

         /**
          * @description
          * This method is used to handle the start customization event.
          */
            public startCustmization(){
                this.startCustomizationEvent.emit();
            }
         /**
          * @description
          * This method is used to handle the slot action.
          * @param type
          * @param modalId
          */
            public handleSlotAction(type: string,modalId:string){
                this.handleSlotEvent.emit({ type, modalId });
            }
   
    /**
     * @description
     * This method is used to handle the add anyway action.
     */
    public handleAddAnywayAction(type: string) {
        this.analyticsEvents('modalClick', 'deli:only-available-in-time|got-it-add-anyways');
        this.addAnywayEvent.emit(type);
    }
    /**
     * @description
     * This method is used to handle the add and update item event.
     */
    public handleAddAndUpdateItem(type: string) {
        this.analyticsEvents('topNav', 'only-available-in-time:add-item-and-update-time');
        this.addAndUpdateEvent.emit(type);
    }
         /**
          * @description
          * This method is used to handle the add item from previous customization event.
          */
       public handleAddItemFromPreviousCustomization(){
            this.addPreviousCustomizationEvent.emit();
       }
    
       /**
        * @description
        * This method is used to handle the add item for preorder products
        */
        public handlePreorderItem(): void {
            this.addPreorderItemEvent.emit();
        }

    /**
     * @description
     * This method is used to handle the back button click event.
     */
    public previousPageAction(): void {
        this.previousPageEvent.emit();
    }
    
    public handleModifyPreviousCustomization(){
        this.addModifyPreviousCustomizationEvent.emit();
    }

    public get isRequiredIngredientOutOfStock(): boolean {
        if (!this.customizationData?.items?.length) return false;
        const customizations = this.customizationData?.items?.[0]?.customizations || [];
        return customizations.some( item => {
            if (!item?.options?.length || !item?.minSelect) return false;
            const availableCount = item?.options.filter(
                option => option?.channelInventory?.[this.reservedTimeIntent] === '1'
            ).length;
            return availableCount < item?.minSelect;
        });
    }

    public analyticsEvents(event: string, modalAction: string) {
        if (window['AB'] && window['AB']['DATALAYER']) {
            window['AB']['DATALAYER'].handleModalAndLinkEvents({eventType: event, modalAndLinkData: event === 'topNav' ? `cta:${window['AB']['DATALAYER'].pathSections?.join(':')}|button|${modalAction}` : modalAction});
        }
    }
}